<template>
  <div class="card mat10">
    <div class="flex-s-c title-border" style="margin:0 0 10px">
      <span class="name">{{$route.params.year}}积分明细</span>
    </div>
    <div class="flex-s-s" style="position: relative">
      <!-- <div class="flex-s-c score-card">
        <div>
          <i class="iconfont icon-jifen1"></i>
          <div class="mat10">本年度积分（分）</div>
        </div>
        <div class="value">36</div>
      </div> -->
      <ul class="key-value">
        <li v-for="item in examineList">
          <div class="key">{{item.key}}：</div>
          <div class="value">{{item.value}}</div>
        </li>
      </ul>
    </div>
    <!-- <el-button type="primary">申请保留资格</el-button> -->
    <el-table :data="tableData" stripe style="width: 100%" class="mat10">
      <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in column">
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      examineList: [
        { key: "本年度积分 ", value: "2010-10-10" },
        { key: "志委会年限", value: "12人" },
        { key: "展厅数量", value: "2010-10-10" }
      ],
      tableData: [],
      column: [
        { prop: "classification", label: "所属分类", width: "" },
        { prop: "integralItem", label: "积分项目", width: 90 },
        { prop: "integralStr", label: "获得积分", width: "" },
        { prop: "createTime", label: "获得积分时间", width: "" },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 100,
      dialogVisible: false,
      userMess: this.$store.state.user.user,
    };
  },
  computed: {},
  watch: {},
  methods: {
    getList() {
      // console.log(params)
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        yearSelect: this.$route.params.year,
        volunteerId: this.userMess.id
      }
      this.$api.getIntegralItem(params).then(res => {
        // console.log(res)
        this.tableData = res.data.rows.map(item => {
          let integralStr
          if (item.integralType == 1) integralStr = '+' + item.integral
          if (item.integralType == 2) integralStr = '-' + item.integral
          return { ...item, integralStr: integralStr }
        })
        this.total = res.data.total
      })

    },

    detail(scope) {
      this.$router.push({ name: 'myScoreDetail', params: { id: scope.row.id } })

    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getDetail()
    this.getList();
    this.examineList = [
      { key: "本年度积分 ", value: this.$route.params.score },
    ]

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@import "./score.less";
</style>
